module.exports = __webpack_public_path__ + "img/notice_warning.0fee02d6.svg";